import { render } from "./punishMent.vue?vue&type=template&id=07b4785e"
import script from "./punishMent.vue?vue&type=script&lang=js"
export * from "./punishMent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__